import React from "react";
import "./../../styles/pages/CustomPage.css";
import cathedralImage from "../../assets/puerta.jpg";

const AboutPage = () => {
  return (
    <div className="msf-container">
      {/* Fila superior: Texto a la izquierda, imagen a la derecha */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">Sobre Nosotras</h2>
          <div className="red-line"></div>
          <p>
            Proyecto Chicas Rosas es una Asociación sin ánimo de lucro, fundada
            en Sevilla el 22 de enero de 2021 (registro de la Junta de Andalucía
            nº 41-1-19776), integrada por mujeres que han padecido o padecen
            cáncer de mama, familiares de chicas rosas, profesionales sanitarios
            y colaboradores. Nuestro objetivo como asociación es fomentar la
            actividad física, invitar a caminar mediante la organización de
            rutas de senderismo o rutas por las zonas verdes de la ciudad. Y la
            organización anual del Camino de Santiago con todos aquellos socios
            que quieran adherirse a dicha actividad.
          </p>
          <p>
            El grupo que conforma la a asociación ha ido creciendo gracias al
            trabajo de mujeres afectadas, familiares, personal sanitario y
            colaboradores que de forma generosa y desinteresada participan en
            este proyecto.
          </p>
          <p>
            La confianza, colaboración y participación de todos los miembros nos
            dan fuerza para seguir cumpliendo objetivos con la certeza de que el
            ejercicio físico tiene un gran efecto protector para todos y más aún
            para aquellos hombres o mujeres que padecen cáncer.
          </p>
          <p>
            La asociación está abierta a la sociedad para concienciar sobre la
            importancia del diagnóstico precoz del cáncer de mama y el papel
            preventivo de los hábitos saludables: comida sana, buena compañía,
            actividad física moderada, desarrollo intelectual y disfrute de la
            naturaleza.
          </p>
        </div>
        <div className="msf-image">
          <img src={cathedralImage} alt="Medical assistance worldwide" />
        </div>
      </div>

      {/* Fila inferior: Imagen a la izquierda, texto a la derecha */}
      <div className="msf-row full-width">
        <div className="msf-text full-width-text">
          <h2 className="custom-page-h2">Objetivos, misión y visión</h2>
          <div className="red-line-full-width"></div>
          <h3>Objetivos</h3>
          <ul>
            <li>
              Fomentar la actividad deportiva mediante la organización de
              convocatorias periódicas de senderismo y en especial la
              organización anual del Camino de Santiago con todos aquellos
              socios que quieran adherirse a dicha actividad.
            </li>
            <li>
              Orientar a mujeres u hombres que han padecido o padecen cáncer de
              mama, para que conozcan las características de su enfermedad, su
              evolución y tratamiento.
            </li>
            <li>
              Concienciar de la problemática social que el cáncer de mama
              conlleva para la persona afectada y su entorno.
            </li>
            <li>
              Asesorar en los problemas específicos que la nueva situación
              genera, para que puedan gozar de una mejor calidad de vida.
            </li>
            <li>
              Asociar la actividad física con la disminución del riesgo de
              recurrencia.
            </li>
            <li>
              Informar y formar sobre la importancia del diagnóstico precoz del
              cáncer de mama y por qué hay que realizarse una mamografía
              periódicamente.
            </li>
            <li>
              Recomendar el ejercicio como parte de la terapia contra el cáncer
              de mama y sus secuelas, individualizando el modo, intensidad,
              duración, frecuencia y progresión según el momento de la
              enfermedad.
            </li>
            <li>
              Adquirir pautas de comportamiento que posibiliten un bienestar
              físico y mental.
            </li>
            <li>
              Tomar conciencia de los beneficios de la actividad física incluso
              durante los tratamientos, ya que retrasa la aparición de debilidad
              muscular, reduce el riesgo de osteoporosis, disminuye el desánimo
              y la depresión, mejorando la autoestima y favoreciendo las
              relaciones sociales.
            </li>
            <li>
              Elaborar un plan de actividades para la prevención del linfedema
              teniendo presentes diferentes ejercicios activos y aeróbicos.
            </li>
            <li>
              Fomentar hábitos de vida saludable que nos inviten a vivir más y
              mejor.
            </li>
            <li>
              Participar y adherirse en la constitución de aquellos organismos
              de carácter autonómico, nacional o internacional, que tengan como
              objetivo actuaciones similares a las de esta Asociación.
            </li>
            <li>
              Representar y defender los intereses de las mujeres afectadas por
              el cáncer de mama ante Organismos Públicos y Privados de toda
              índole, requiriendo de dichas entidades la atención y ayudas que
              este perfil de pacientes precisa.
            </li>
            <li>
              Reivindicar la importancia de acortar los plazos de respuesta en
              las distintas fases de la reconstrucción mamaria.
            </li>
          </ul>

          <h3>Misión</h3>
          <p>
            La asociación “PROYECTO CHICAS ROSAS” nace para invitar a caminar a
            mujeres que han padecido cáncer de mama, promoviendo el ejercicio
            físico como terapia efectiva para la mayoría de las supervivientes
            de esta enfermedad, destacando como resultado la calidad de vida de
            la mujer durante y después del tratamiento. Estos beneficios se
            extienden a aspectos de carácter psíquico y social, ya que facilitan
            la socialización generando sentimientos de pertenencia y de ser
            agentes de acción, lo que devuelve a las mujeres el control de su
            situación.
          </p>

          <h3>Visión</h3>
          <p>
            Pretendemos empoderar a las mujeres que han padecido o padecen
            cáncer de mama, invitándolas a mejorar su calidad de vida, para que
            sean referentes de recuperación de la salud física y mental,
            superando el reto físico y mental de hacer el Camino de Santiago,
            percibiendo que no están solas y que el “PROYECTO CHICAS ROSAS”
            existe para apoyarlas.
          </p>
        </div>
      </div>
    </div>
  );
};
export default AboutPage;
